export const BASED_ON_RECENT_VIEWS_LIMIT = 20;
export const BASED_ON_RECENT_VIEWS_LIMIT_EXTENDED = 50;
export const BASED_ON_RECENT_VIEWS_VISIBLE_COUNT = 6;
